import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import type { Entity } from "@cohesive/api-entities";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export function useNotionMCPTeams(
  connection: IntegrationConnection,
  options?: Partial<UseQueryOptions<Entity[], Error>>,
) {
  return useQuery<Entity[], Error>({
    queryKey: ["notion-mcp-teams", connection.id],
    queryFn: async () => {
      const response = await orgAPI.toolbox.execute<Entity[]>({
        integration_connection_id: connection.id,
        action_name: "notion-mcp-get-teams",
        action_input: {},
      });
      return response.data;
    },
    enabled: !!connection.integration_id,
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...options,
  });
}
